import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Icon } from "discover.medical.react-component-library";
import { Button } from "./BackToTopBtn.styled";
import { logBackToTopClicked } from "../../utils/analytics";

const scrollToTop = () => {
  if (typeof document !== "undefined") {
    const scrollingElement = document.scrollingElement
      ? document.scrollingElement
      : document.documentElement;

    scrollingElement.scrollTop = 0;
  }
};

const BackToTopBtn = ({ showLabel }) => {
  const [isBackToTopVisible, setBackToTopVisibility] = useState(false);

  useEffect(() => {
    const handleWindowScroll = () => {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      //Show when 75% of top page is no longer visible
      const showAt = 0.75 * window.innerHeight;
      //Hide when only 50% of top page is not shown
      const hideAt = 0.5 * window.innerHeight;
      //no need to refire this if back to top is already visible
      if (!isBackToTopVisible && scrollTop >= showAt) {
        setBackToTopVisibility(true);
      }
      //no need to refire this if back to top is already hidden
      if (isBackToTopVisible && scrollTop < hideAt) {
        setBackToTopVisibility(false);
      }
    };
    window.addEventListener("scroll", handleWindowScroll);

    return () => {
      window.removeEventListener("scroll", handleWindowScroll);
    };
  }, [isBackToTopVisible]);

  const handleClick = () => {
    logBackToTopClicked(window.scrollY);
    scrollToTop();
  };

  return (
    <Button
      variant="secondary"
      kind="text"
      padded={false}
      size={"sm"}
      $isVisible={isBackToTopVisible}
      onClick={handleClick}
      aria-label={!showLabel ? "Back to Top" : ""}
    >
      <Icon
        icon={{
          size: "xs",
          glyph: "arrow_upward",
          color: "white"
        }}
        background={{
          color: "white"
        }}
      />
      {showLabel ? <span>Back to Top</span> : <></>}
    </Button>
  );
};

BackToTopBtn.propTypes = {
  showLabel: PropTypes.bool
};

export default BackToTopBtn;
